<template lang="pug">
	.storyboard-preview-create(v-if="showed && Version.SelectedVersion" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span Create New Storyboard Preview
			.card-body.collapse.show
				.form-horizontal(v-if="state === 'create'")
					.form-group
						label.col-form-label Preview URL
						.controls
							select.custom-select.custom-select-sm(v-model="previewUrl")
								option(v-for="url in previewUrls" :key="url" :value="url") {{url}}
					.separator
					.form-group
						label.col-form-label Preview type
						.controls
							select.custom-select.custom-select-sm(v-model="previewType")
								option(value="html") HTML
								option(value="screenshot") Screenshot
					template(v-if="previewType === 'html'")
						.form-group
							label.col-form-label Preview scale
							.controls
								InputRangeDouble(v-model="editorScales" :default="[0.1, 1.2]" :min="0.1" :max="5" :step="0.1" theme="dark-mini")
						.form-group
							label.col-form-label Preview overflow
							.controls
								InputSwitch(v-model="editorOverflow" theme="default")
						.form-group
							label.col-form-label Single file
							.controls
								InputSwitch(v-model="singleFile" theme="default")
					template(v-else-if="previewType === 'screenshot'")
						.form-group
							label.col-form-label Image type
							.controls
								select.custom-select.custom-select-sm(v-model="imageType")
									option(value="png") PNG
									option(value="jpg") JPG
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="createPreview()") Create new preview
						button.btn.btn-ghost-dark(type="button" @click="closeWindow()") Cancel
				.form-center(v-if="state === 'waiting'")
					.form-group
						.text.icon.fa.fa-spinner.fa-spin
				.form-horizontal(v-if="state === 'error'")
					.form-group
						.text.danger Error: {{ errorMessage }}
					.form-actions
						button.btn.btn-ghost-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';
	import { Layout }			from './../../services/Layout';
	import { Server }			from './../../services/Server';
	import { Metadata } 		from './../../services/Metadata';
	import SetupSettings 		from './../../settings/settings';

	import InputRangeDouble 	from './../Editor/Controls/InputRangeDouble';
	import InputSwitch 			from './../Editor/Controls/InputSwitch';

	import * as htmlToImage 	from 'html-to-image';

	export default {
		name: "PreviewCreateStoryboard",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show PreviewCreateStoryboard": function() {

					this.update();

				},
				"Server Data:PreviewCreateError": function(data) {

					if (this.state !== 'waiting') return;
					if (data.versionId !== Version.SelectedVersion?.id) return;

					this.state = 'error';
					this.errorMessage = data.error;

				}
			}
		},
		components: {
			InputRangeDouble,
			InputSwitch
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Metadata = Metadata;

			let defaultPreviewUrl = (Metadata.Config['preview-urls'] || [])[0] || '';

			return {
				previewUrl: defaultPreviewUrl,
				previewType: 'html',
				imageType: 'png',
				editorScales: [0.1, 1.2],
				editorOverflow: false,
				singleFile: false,
				state: 'create',
				errorMessage: ''
			};

		},
		computed: {
			previewUrls() {

				return Metadata.Config['preview-urls'];

			}
		},
		watch: {
			previewUrl() {

				this.saveSettings();

			},
			previewType() {

				this.saveSettings();

			},
			imageType() {

				this.saveSettings();

			},
			editorScales: {
				deep: true,
				handler() {

					this.saveSettings();

				}
			},
			editorOverflow() {

				this.saveSettings();

			},
			singleFile() {

				this.saveSettings();

			}
		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				this.restoreSettings();

			},
			// Захват скриншота iframe с превью сториборда в виде Blob
			async captureIframeScreenshotBlob() {

				let iframe = document.querySelector('.preview-frame iframe') || document.querySelector('iframe');
				if (!iframe) throw new Error("Preview iframe not found");

				let contentDoc = iframe.contentWindow?.document || iframe.contentDocument;
				let contentWin = iframe.contentWindow;

				if (!contentDoc) throw new Error("Preview iframe document not accessible");

				// Снимаем выделение и подсветку с активных элементов в редакторе перед снятием скриншота
				if (contentWin?.HTMLRenderer?.Editor?.unselectElement) contentWin.HTMLRenderer.Editor.unselectElement();
				if (contentWin?.HTMLRenderer?.Editor?.unhighlightElement) contentWin.HTMLRenderer.Editor.unhighlightElement();

				let previewSize = Layout.getPreviewSize();
				let width = previewSize?.width || contentDoc.documentElement?.clientWidth || contentDoc.body?.clientWidth || iframe.clientWidth;
				let height = previewSize?.height || contentDoc.documentElement?.clientHeight || contentDoc.body?.clientHeight || iframe.clientHeight;

				let canvas = await htmlToImage.toCanvas(contentDoc.body, {
					backgroundColor: this.imageType === 'jpg' ? '#ffffff' : undefined,
					width: width,
					height: height,
					canvasWidth: width,
					canvasHeight: height,
					pixelRatio: 1,
					filter: el => {
						return el.name !== 'ControlElementOverlay' &&
							el.name !== 'ControlElementContour' &&
							el.name !== 'ControlElementSelection';
					}
				});

				let mimeType = this.imageType === 'jpg' ? 'image/jpeg' : 'image/png';

				return new Promise(resolve => {
					canvas.toBlob(blob => {
						resolve(blob);
					}, mimeType, 0.95);
				});

			},
			async createPreview() {

				this.saveSettings();

				Broadcast.call("New Preview Creating");
				this.state = 'waiting';

				Broadcast.once("New Preview Created", () => {

					Broadcast.call("Show PreviewList");
					this.hide();
					this.state = 'create';

				});

				if (this.previewType === 'screenshot') {

					try {

						let blob = await this.captureIframeScreenshotBlob();

						let formData = new FormData();
						let clientData = {
							versionId: Version.SelectedVersion.id,
							previewUrl: this.previewUrl,
							previewType: this.previewType,
							imageType: this.imageType,
							size: Layout.getPreviewSize(),
							singleFile: this.singleFile,
							editorScales: this.editorScales,
							editorOverflow: this.editorOverflow
						};

						formData.append('clientData', JSON.stringify(clientData));
						formData.append('file', blob, `screenshot.${this.imageType}`);

						let url = `${location.protocol}//${SetupSettings["domain"]}/storyboard/preview/create`;

						let xhr = new XMLHttpRequest();
						xhr.open("POST", url);
						Auth.authorizeRequest(xhr);
						xhr.onload = () => {

							if (xhr.status >= 200 && xhr.status < 300) return;

							this.state = 'error';
							this.errorMessage = xhr.responseText || xhr.statusText || 'Request failed';

						};
						xhr.onerror = () => {

							this.state = 'error';
							this.errorMessage = 'Network error';

						};
						xhr.send(formData);

					} catch (e) {

						console.error("Screenshot preview creation error:", e);
						this.state = 'create';

					}

				} else {

					Server.sendToSocket({
						CreateStoryboardPreview: {
							versionId: Version.SelectedVersion.id,
							previewUrl: this.previewUrl,
							size: Layout.getPreviewSize(),
							singleFile: this.singleFile,
							editorScales: this.editorScales,
							editorOverflow: this.editorOverflow
						}
					});

				}

			},
			// Восстановление сохраненных пользователем настроек из LocalStorage
			restoreSettings() {

				// Preview URL
				let savedUrl = window.localStorage.getItem('preview-create-storyboard-preview-url');
				let availableUrls = Metadata.Config['preview-urls'] || [];
				if (savedUrl && availableUrls.includes(savedUrl)) {

					this.previewUrl = savedUrl;

				} else {

					this.previewUrl = availableUrls[0] || '';

				}

				// Preview type (html или screenshot)
				let savedPreviewType = window.localStorage.getItem('preview-create-storyboard-preview-type');
				if (savedPreviewType === 'screenshot' || savedPreviewType === 'image') {

					this.previewType = 'screenshot';

				} else {

					this.previewType = 'html';

				}

				// Image type (png или jpg)
				let savedImageType = window.localStorage.getItem('preview-create-storyboard-image-type');
				if (savedImageType === 'jpg' || savedImageType === 'png') {

					this.imageType = savedImageType;

				} else {

					this.imageType = 'png';

				}

				// Preview scale
				let savedScales = window.localStorage.getItem('preview-create-storyboard-editor-scales');
				if (savedScales) {

					try {

						let parsed = JSON.parse(savedScales);
						if (Array.isArray(parsed) && parsed.length === 2 && typeof parsed[0] === 'number' && typeof parsed[1] === 'number' && !isNaN(parsed[0]) && !isNaN(parsed[1])) {

							this.editorScales = parsed;

						} else {

							this.editorScales = [0.1, 1.2];

						}

					} catch(e) {

						this.editorScales = [0.1, 1.2];

					}

				} else {

					this.editorScales = [0.1, 1.2];

				}

				// Preview overflow
				let savedOverflow = window.localStorage.getItem('preview-create-storyboard-editor-overflow');
				if (savedOverflow !== null) {

					this.editorOverflow = (savedOverflow === 'true' || savedOverflow === true);

				} else {

					this.editorOverflow = false;

				}

				// Single file
				let savedSingleFile = window.localStorage.getItem('preview-create-storyboard-single-file');
				if (savedSingleFile !== null) {

					this.singleFile = (savedSingleFile === 'true' || savedSingleFile === true);

				} else {

					this.singleFile = false;

				}

			},

			// Сохранение настроек экрана в LocalStorage
			saveSettings() {

				if (this.previewUrl) window.localStorage.setItem('preview-create-storyboard-preview-url', this.previewUrl);

				window.localStorage.setItem('preview-create-storyboard-preview-type', this.previewType);
				window.localStorage.setItem('preview-create-storyboard-image-type', this.imageType);

				if (Array.isArray(this.editorScales)) window.localStorage.setItem('preview-create-storyboard-editor-scales', JSON.stringify(this.editorScales));

				window.localStorage.setItem('preview-create-storyboard-editor-overflow', this.editorOverflow);
				window.localStorage.setItem('preview-create-storyboard-single-file', this.singleFile);

			}
		}
	}
</script>


<style lang="sass">

	.storyboard-preview-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		transition: opacity 0.2s

		.card
			width: 400px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			.btn-ghost-dark
				float: right
				color: #fff

			.form-horizontal
				display: flex
				flex-direction: column

				.form-group
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center
					margin-bottom: 0.5rem

				.separator
					width: 100%
					height: 1px
					border-bottom: 1px solid rgba(255, 255, 255, 0.1)
					margin-bottom: 0.5rem

				.form-actions
					margin-top: 10px

		.form-center
			text-align: center
			padding: 20px

			.icon
				font-size: 32px
				color: #5c6873

</style>
